<template>
  <div>
    <div class="banner"></div>
    <div class="doctors">
      <img class="info-avatar"
           :src="baseURL + doctor.avatar"
           alt="">
      <div class="doctor-info">
        <h3 v-html="setDoctorName(doctor.name)"
            class="info-name">
        </h3>
        <p class="info-good-at">
          <span>科室</span>{{doctor_disease}}</p>
        <!-- <div class="info-titles">
                    <p v-for="(depart,index) in doctor.department_name" :key="index">{{depart}}</p>
                </div> -->
        <button class="button-order"
                @click="orderNow(doctor.hospital_id)">立即预约</button>
      </div>
    </div>
    <div class="doc-body">
      <!-- <Bread class="bread"/> -->
      <Breadcrumb class="bread"
                  separator=">">
        <!-- <BreadcrumbItem to="/">
                    <img class="bread-icon" src="../assets/images/icon-location.png"/>首页
                </BreadcrumbItem> -->
        <BreadcrumbItem to="/doctorList/0">权威专家</BreadcrumbItem>
        <BreadcrumbItem class="bread-last">
          {{doctor.name}}

        </BreadcrumbItem>
      </Breadcrumb>
      <div class="doc-detail">
<!--        <h4>名医简介
          <span>Introduction to famous doctors</span>
        </h4>-->
        <div class="mb52">
          <p v-html="doctor.brief"></p>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import avatar from '@/assets/images/doctor/doctor.png'
import * as api from '@/api/login';
import * as apis from '@/api/doctor'
import { baseURL } from '@/api/axios'
import { getLocalStorage } from '@/utils/tools.js'
// import {Text2Html} from '../../public/js/util.js'
export default {
  data () {
    return {
      avatar,
      baseURL: baseURL,
      doctor: {
        achievement: "",
        area_id: 0,
        area_name: "",
        avatar: "",
        brief: "",
        created_at: "2019-06-29 02:03:46",
        department_id: "",
        experience: "",
        id: 1,
        learn: "",
        name: "",
        occupational: "",
        research_direction: "",
        school_graduation: "",
      },
      doctor_disease: []
    }
  },
  filters: {
    tohtml: (str) => {
      str = str.replace(/\n/gi, "<br/>");
      str = str.replace(/\\r/gi, "<br/>");
      return str;
    },

  },
  components: {

  },
  mounted () {
    let id = this.$route.params.id;

    this.getDoctorDetail(id)
  },
  methods: {
    async getDoctorDetail (id) {

      try {
        let data = {
          id: id
        }
        let res = await apis.getDoctorInfo(data);
        if (res.code == 200) {
          this.doctor = res.data;

          let diseases = [];
          res.data.doctor_disease.forEach(item => diseases.push(item.disease_name));
          this.doctor_disease = diseases.join(',')
          this.setDoctorName(res.data.name)
          localStorage.setItem('hospital_type', this.doctor.form_type);
        }
      } catch (e) {
        console.log(e)
      }
    },
    async orderNow (id) {
      // this.$router.push('/Agreements');
      let token = getLocalStorage('token');
      let res = await api.getUserInfoData({ token });
      if (res) {
        let type = localStorage.getItem('hospital_type');
        if (type.indexOf('1') > -1) {
          this.$router.push({ name: 'Form', params: { hid: id } });
        } else if (type.indexOf('2') > -1) {
          this.$router.push({ name: 'FormOfOne', params: { hid: id } });
        } else if (type.indexOf('3') > -1) {
          this.$router.push({ name: 'FormOfTwo', params: { hid: id } });
        } else if (type.indexOf('4') > -1) {
          this.$router.push({ name: 'FormOfThree', params: { hid: id } });
        }
      } else {
        this.$router.push({
          name: 'Agreements',
          params: {
            hid: id
          }
        });
      }


    },
    setDoctorName (name) {
      if (name) {
        return name.replace(/\n/g, "<br/>");
      } else {
        return ''
      }

      // let nameArr,
      //   str
      // if (name.includes('（')) {
      //   nameArr = name.split("（")
      //   let fullName = ''
      //   if (nameArr.length > 1 && nameArr[1]) {
      //     fullName = '（' + nameArr[1]
      //   }
      //   str = nameArr[0] + '<br>' + fullName
      // } else if (name.includes('(')) {
      //   nameArr = name.split("(")
      //   let fullName = ''
      //   if (nameArr.length > 1 && nameArr[1]) {
      //     fullName = '(' + nameArr[1]
      //   }
      //   nameArr = name.split("(")
      //   str = nameArr[0] + '<br>' + fullName
      // }
      // this.doctor.name = str
    }
  }
}
</script>
<style lang="less" scoped>
.banner {
  height: 250px;
  background: url('../assets/images/doctor/banner2.jpg') no-repeat center;
}
.doctors {
  width: 970px;
  height: 400px;
  background: #fff;
  padding: 40px 70px;
  margin: -150px auto 0;
  .info-avatar {
    width: 309px;
    height: 309px;
    background: url('../assets/images/doctor/bg-doctor.png') no-repeat center;
    padding: 1px;
    border-radius: 155px;
    margin-right: 90px;
  }
  .doctor-info {
    display: inline-flex;
    flex-direction: column;
    justify-content: space-between;
    width: 424px;
    height: 309px;
    vertical-align: top;
    .info-name {
      font-size: 30px;
      color: #333130;
      line-height: 46px;
      font-weight: normal;
      margin-bottom: 20px;
    }
    .info-good-at {
      font-size: 22px;
      color: #ae1e10;
      line-height: 40px;
      margin-bottom: 35px;
      span {
        display: inline-block;
        // width: 62px;
        // height: 28px;
        width: 72px;
        height: 40px;
        background: url('../assets/images/doctor/icon2.png') no-repeat center;
        color: #ffffff;
        font-size: 15px;
        line-height: 40px;
        text-align: center;
        margin-right: 10px;
      }
    }
    .info-titles {
      p {
        font-size: 18px;
        line-height: 38px;
      }
      margin-bottom: 35px;
    }
  }
}
.bread {
  margin: 30px 0;
}
.doc-detail {
  width: 970px;
  background: #fff;
  border: 1px solid #dcdcdc;
  padding: 55px 70px 100px 60px;
  margin-bottom: 115px;
  h4 {
    font-size: 30px;
    color: #ae1e10;
    font-weight: normal;
    margin-bottom: 38px;
    span {
      color: #898888;
      font-size: 18px;
    }
  }
  p {
    color: #797576;
    font-size: 22px;
    line-height: 38px;
  }
  .doc-type {
    font-size: 26px;
    color: #fff;
    line-height: 52px;
    padding-left: 20px;
    margin-bottom: 10px;
  }
  .type1 {
    background: url('../assets/images/doctor/icon-title1.png') no-repeat left
      center;
  }
  .type2 {
    background: url('../assets/images/doctor/icon-title2.png') no-repeat left
      center;
  }
}
</style>
<style>
.mb52 p p span {
  font-family: 'Noto Sans SC' !important;
}
.doctors {
  font-family: 'Noto Sans SC' !important;
}
</style>
